module.exports = __webpack_public_path__ + "media/VID-20250830-WA0075.cc899921.mp4";